// utils/getRootData.ts
export default function getRootData<T = unknown>(id = 'root-data'): T | null {
  //console.log(`getRootData: ${id}`);
  const el = document.getElementById(id)
  if (!el) return null
  try {
    return JSON.parse(el.textContent || '') as T
  } catch (e) {
    console.error('Invalid JSON in root-data:', e)
    return null
  }
}
